module.exports = __webpack_public_path__ + "img/intercomdescribe5.86768380.png";